export default __webpack_public_path__ + "static/media/oval.82eb0de4.png";